module.exports = __webpack_public_path__ + "assets/images/project/changi-village/02.jpg?v=2632f7c4";